import { useBoard, useCalls } from '../../lib/data';
import { Icon } from '../../ui/icons';
import { Chead, ErrorBox, useDrawer } from '../../ui/kit';
import { CallRow } from '../rows';

export function Calls() {
  const calls = useCalls();
  const { open } = useDrawer();
  const board = useBoard();
  const linked = new Set((board.data ?? []).map((l) => l.id));
  const all = calls.data ?? [];
  // Dismissed meetings (not sales calls) are hidden from both lists.
  const review = all.filter((c) => c.status === 'review' || c.status === 'unlinked');
  const done = all.filter((c) => c.status === 'done');
  const row = (c: (typeof all)[number]) => (
    <CallRow key={c.id} call={c} linked={Boolean(c.lead_id && linked.has(c.lead_id))} />
  );

  return (
    <>
      <div className="head">
        <div>
          <h1>
            Call <span className="grad">reviews</span>
          </h1>
          <p>
            Sales calls from Read.ai with the promises and the next step. You check them and
            confirm.
          </p>
        </div>
        <button className="btn primary big" onClick={() => open({ type: 'newCall' })}>
          Add call <Icon name="arrow" />
        </button>
      </div>
      <ErrorBox error={calls.error} />
      <section className="card sec">
        <Chead label="To review" cls="g" />
        {calls.isLoading ? (
          <div className="loading">Loading…</div>
        ) : review.length ? (
          review.map(row)
        ) : (
          <div className="empty">No calls waiting.</div>
        )}
      </section>
      <section className="card sec">
        <Chead label="Confirmed" cls="p" />
        {done.length ? done.map(row) : <div className="empty">No confirmed calls yet.</div>}
      </section>
    </>
  );
}
